<template>
  <b-nav-item-dropdown right no-caret :disabled="closed" >
    <template v-slot:button-content>
      <span class="material-icons-outlined align-middle text-white">notifications</span>
      <span
        v-if="notificationsCount !== 0 && !closed"
        class="bg-danger position-absolute text-white small rounded-pill txt-center"
        >{{ notificationsCount }}</span
      >
    </template>
    <b-dropdown-item>
      <span v-if="notificationsCount == 0" class="d-block text-center">
        <span class="material-icons-outlined full-icon align-middle mt-2 mb-2">notifications</span>
        <p class="text-muted mx-5 text-wrap">
          You don't have any notification yet.
        </p>
      </span>
      <span v-else>
        <div v-for="notification in notificationsList" :key="notification.id" class="bg-light">
          <notification-collapse-group
            :isParent="isParent"
            :notification="notification"
            @onReadNotification="readNotification"
            @onAcceptItem="handleAcceptingItem"
            @onRejectItem="handleAcceptingItem"
          >
          </notification-collapse-group>
        </div>
        <b-link @click="$router.push({ name: 'notifications' })">
          <small class="text-center text-main d-block py-2">
            Show all
          </small>
        </b-link>
      </span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { useSessionStore, useNotificationStore } from '@/common';
import notificationsActionMixin from '../mixins/notificationsAction.mixin';
import NotificationCollapseGroup from './NotificationCollapseGroup.vue';
import { getNotifications } from '../index';

export default {
  components: { NotificationCollapseGroup },
  mixins: [notificationsActionMixin],
  props: {
    isParent: { type: Boolean, default: false },
    childId: { type: String, required: true },
  },
  data() {
    const sessionStore = useSessionStore();
    const notificationStore = useNotificationStore();
    return {
      notificationsList: [],
      sessionStore,
      notificationStore,
    };
  },
  async mounted() {
    if (this.$route.name !== 'notifications') {
      await this.getNotificationsController();
    }
  },
  computed: {
    closed() {
      return this.$route.name === 'notifications';
    },
    notificationsCount() {
      return this.notificationStore.total;
    },
    currentChild() {
      return this.sessionStore.childSelectedId;
    }
  },
  methods: {
    async getNotificationsController() {
      const { notifications, total = 0 } = await getNotifications(this.childId, this.isParent);
      this.notificationsList = notifications;
      this.notificationStore.updateTotal(total);
    }
  },
  watch: {
    async currentChild() {
      try {
        this.notificationsList = [];
        await this.getNotificationsController();
      } catch (error) {
        console.error(error)
      };
    }
  }
};
</script>
<style lang="scss">
.notifications {
  .small {
    font-size: 50% !important;
    width: 15px;
    right: -4px;
  }

  .b-nav-dropdown {
    list-style: none !important;
  }

  .dropdown-menu {
    max-height: 80vh;
    width: min(92vw, 390px);
    padding: 0 !important;
    overflow-y: scroll;
    border-radius: 10px;
  }
  .dropdown-item {
    padding: 0 !important;
  }

  .nav-link {
    padding: 0 !important;
    display: flex;
    align-items: center;
  }
}
</style>

